var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "h-button",
      class: _vm.buttonClasses,
      attrs: { disabled: _vm.disabled, type: "button" },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _vm.icon !== undefined
        ? _c(
            "div",
            { staticClass: "h-button__icon" },
            [_c("svg-icon", { attrs: { "{...icon}": "" } })],
            1
          )
        : _vm._e(),
      _c(
        "span",
        { staticClass: "h-button__label" },
        [_vm._v(" " + _vm._s(_vm.label) + " "), _vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }